export const googleAPIKey = "AIzaSyC8EFXuIwNdJVSEzVOCIDJeCRM2Rhuj8VY";
